import * as rmd from 'material-ui';
import React, { Component } from 'react';
import config from 'cfg';
import _ from 'lodash';
import moment from 'moment';

const YEARS = _.range(2001, +moment().format('YYYY') + 1).reverse();

class F1GrandPrixPicker extends Component {
    static defaultProps = {};

    constructor(props, context) {
        super(props, context);

        this.state = {
            year: props.year || moment().year(),
            gpxId: props.gpxId || null
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        const { year } = this.state;

        return fetch(`${config.apis.ss2}/f1/gpx?year=${year}`)
            .then(response => response.json())
            .then(gp => {
                this.setState({
                    grandPrix: _.sortBy(gp, 'startDate')
                });
            })
            .catch(e => {
                console.error(e);
            });
    }

    handleYearChange = (e, key, payload) => {
        this.setState({ year: payload, gpxId: undefined, disabled: false }, () => {
            // this.props.onChange({ year: payload, gpxId: undefined });
            this.props.onChange(this.getPropertyFor('year'), payload);
            this.loadData();
        });
    };

    handleGrandPrixChange = (e, key, payload) => {
        this.setState({ gpxId: payload }, () => {
            this.props.onChange(this.getPropertyFor('gpxId'), payload);
        });
    };

    getPropertyFor(key) {
        return _.get(this, `props.propsMap[${key}]`, key);
    }

    render() {
        if (!this.state.grandPrix) return null;

        return (
            <div>
                <rmd.SelectField
                    style={{ width: '100%' }}
                    value={this.state.year}
                    floatingLabelText="Year"
                    onChange={this.handleYearChange}
                >
                    {YEARS.map(y => {
                        return <rmd.MenuItem key={y} value={y} primaryText={y} />;
                    })}
                </rmd.SelectField>
                <rmd.SelectField
                    style={{ width: '100%' }}
                    value={this.state.gpxId}
                    floatingLabelText="Grand Prix"
                    onChange={this.handleGrandPrixChange}
                >
                    {this.state.grandPrix.map(gp => {
                        return <rmd.MenuItem key={gp.id} value={gp.id} primaryText={gp.name_en || '---'} />;
                    })}
                </rmd.SelectField>
            </div>
        );
    }
}

export default F1GrandPrixPicker;


/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/F1GrandPrixPicker.js
 **/